import appConstants from '../../../../appConstants';
import { RMAXLogger } from '../../../../services/LoggerService/RMAXLogger';
const DEFAULT_MAX_RETRIES = 3;
const DEFAULT_RETRY_DELAYS = [
  appConstants.ONE_SECOND_TIME_OUT,
  appConstants.ONE_SECOND_TIME_OUT * 2,
  appConstants.ONE_SECOND_TIME_OUT * 3
]; // 1s, 3s, 5s

const isWebGLAvailable = () => {
  try {
    const canvas = document.createElement('canvas');
    return Boolean(
      canvas.getContext('webgl2') ||
        canvas.getContext('webgl') ||
        canvas.getContext('experimental-webgl')
    );
  } catch (_) {
    return false;
  }
};

const createRetryHandler = () => {
  let retryCount = 0;
  let retryTimeout = null;

  const cleanup = () => {
    if (retryTimeout) {
      clearTimeout(retryTimeout);
      retryTimeout = null;
    }
  };

  const reset = () => {
    retryCount = 0;
    cleanup();
  };

  const handleRetry = (retryFn) => {
    if (retryCount >= DEFAULT_MAX_RETRIES) {
      RMAXLogger.error('Map initialization failed after maximum retries', {
        action: 'MapInitialization_MaxRetriesReached',
        retryCount,
        maxRetries: DEFAULT_MAX_RETRIES,
        component: 'TrimbleMap'
      });
      reset();
      return;
    }
    const delay = DEFAULT_RETRY_DELAYS[retryCount] || DEFAULT_RETRY_DELAYS.at(-1);
    const attemptNumber = retryCount + 1;
    RMAXLogger.warn('Map initialization failed, retrying', {
      action: 'MapInitialization_RetryAttempt',
      attemptNumber,
      maxRetries: DEFAULT_MAX_RETRIES,
      retryDelayMs: delay,
      retryDelaySeconds: delay / 1000,
      component: 'TrimbleMap'
    });
    retryTimeout = setTimeout(() => {
      retryCount++;
      retryFn();
    }, delay);
  };

  return {
    handleRetry,
    reset,
    cleanup
  };
};

export { isWebGLAvailable, createRetryHandler };